import { Component, Input } from "@angular/core";
import { LEGAL_BASE_URL } from "../../constants/param-constants";
import { getCustomerServiceInfo } from "../../constants/customer-service-info";
@Component({
    selector: "brand-footer",
    templateUrl: "brand-footer.html",
})

export class BrandFooterComponent {
  @Input() currency: string | null = null;

  get phone(): string {
    return getCustomerServiceInfo(this.currency).phone;
  }

  links = [
    { label: 'Terms', page: `${LEGAL_BASE_URL}/terms` },
    { label: 'Privacy', page: `${LEGAL_BASE_URL}/privacy-policy` },
  ];
  address = `Lone Wolf Ranch 720 Rusk Street 1st Floor Houston, TX 77002`;
  brand = 'Lone Wolf Ranch';
  year: number = new Date().getFullYear();

  // [DEV-54196] Always include noopener,noreferrer (security rule) so the opened window can't reach back via window.opener.
  openLink(url: string): void {
    window.open(url, '_blank', 'width=400, height=400, noopener, noreferrer');
  }
}
